var _defs, _path, _polygon, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _polyline, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _polygon2, _polygon3, _polygon4, _polygon5, _polygon6, _ellipse, _ellipse2, _ellipse3, _ellipse4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEvent(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 400 300",
    width: 0,
    height: 0,
    className: "illustration styles_illustrationTablet__1DWOa",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 176.08,
    y1: 276.41,
    x2: 193.75,
    y2: 260.16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 239.7,
    y1: 229.09,
    x2: 249.74,
    y2: 218.11,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 251.15,
    y1: 236.55,
    x2: 261.16,
    y2: 225.59,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 98.49,
    y1: 233.22,
    x2: 108.53,
    y2: 222.24,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 60.75,
    y1: 218.63,
    x2: 66.62,
    y2: 212.21,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 151.5,
    y1: 197.64,
    x2: 161.54,
    y2: 186.66,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 197.43,
    y1: 194.67,
    x2: 206.9,
    y2: 184.31,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 311.67,
    y1: 205.18,
    x2: 329.95,
    y2: 188.36,
    xlinkHref: "#linear-gradient"
  }))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "pp") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M204.43,291.47l152-89.83c4.84-2.72,9-7.18,4.27-10.1L208.15,103.62c-2.29-1.42-5.76-2.35-8.09-1L40.5,195.23c-4.84,2.81-5.71,10.66-.87,13.47l144.76,82.64A20.21,20.21,0,0,0,204.43,291.47Z",
    fill: "#d740a7"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "99.42 204.24 190.7 255.56 293.98 195.72 204.53 143.99 99.42 204.24",
    fill: "#fcbf17"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M177.75,259.28c-6.7,4.76-16.4,8.58-23.23,13.15l27.63,16.39,24-16.29Z",
    opacity: 0.5,
    fill: "url(#linear-gradient)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260,218l-6.57-3.78c-7.51,4.38-14.92,8.93-22.45,13.28l8.76,4.63C246.56,227.59,253.26,222.8,260,218Z",
    opacity: 0.5,
    fill: "url(#linear-gradient-2)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.84,225l-5.44-2.82c-7.51,4.38-14.92,8.93-22.45,13.28l7.24,3.82C257,234.74,264.13,229.79,270.84,225Z",
    opacity: 0.5,
    fill: "url(#linear-gradient-3)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.76,222.17l-6.57-3.78c-7.51,4.38-14.92,8.93-22.45,13.28l8.76,4.63C105.34,231.72,112,226.94,118.76,222.17Z",
    opacity: 0.5,
    fill: "url(#linear-gradient-4)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.59,212.17,68.76,210c-4.39,2.56-8.72,5.22-13.12,7.76l5.12,2.7C64.76,217.75,68.67,215,72.59,212.17Z",
    opacity: 0.5,
    fill: "url(#linear-gradient-5)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.78,186.59l-6.57-3.78c-7.51,4.38-14.92,8.93-22.45,13.28l8.76,4.63C158.36,196.14,165.06,191.36,171.78,186.59Z",
    opacity: 0.5,
    fill: "url(#linear-gradient-6)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.55,184.24l-6.19-3.57c-7.08,4.13-14.07,8.42-21.17,12.52l8.26,4.37C203.9,193.25,210.22,188.74,216.55,184.24Z",
    opacity: 0.5,
    fill: "url(#linear-gradient-7)",
    style: {
      mixBlendMode: "multiply"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M206.95,119.18c-.63.86-.66,4.64,0,5.05s1.41-.33,1.41-.33.41,2.32,1.08,2.32,5.05-2.15,4.8-4.06-2.56-5.78-2.56-5.78",
    fill: "#ffbb8f"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M154.77,48.49s-.18-4.77-.78-4.9-.93,1.59-1,1.39-1.06-4.89-2-5,0,4.24,0,4.24-3.44.66-3.64,2,4.23,4.83,4.23,4.83",
    fill: "#ffbb8f"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M170.59,175s-.21,3.93-2.33,5.41-4.88,1.91-6,4.14a4,4,0,0,0,.53,4.24,12.76,12.76,0,0,0,7.85-1.49c4.24-2.23,6.26-3.5,7.74-3.82s.08-9.08.08-9.08Z",
    fill: "#341a0c"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M176.18,77.47s-3.94-2.36-5.77-5-15.63-23.94-15.63-23.94-3.52,0-4.51,1.55S162.09,80.6,166,83.56s0,35.21,2,38.17,17.14,5.93,21.09-.69l3-18.18s13.24,14.09,14.23,17.18c0,0,4.08-.14,5.35-3.66S192.52,84.83,189,81.45,176.18,77.47,176.18,77.47Z",
    fill: "#124577"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M172.72,71s-4.84-2.09-3.54-5.22,5.86-5.6,12-2.87,5.21,5.73,4.3,8.86-2.43,5.75-3.39,5.73-3.67-3.26-3.67-3.26",
    fill: "#341a0c"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M173.09,68.08c-.75-.26-.78,12.64,3.78,12.25s5-5.21,5-5.21,3.13-1.82,2.09-3.13-3.13,0-3.13,0L180,68.08S178,69.78,173.09,68.08Z",
    fill: "#ffbb8f"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M168,121.73s-8.38,20.17-7.09,26.19S170.17,178,170.17,178s8.53-1.08,8.24-3.66-5.27-25.53-4.45-28.29c1.08-3.64,4.06-13.86,4.45-11.71s3.81,13.07,6.63,16.51,24,20.05,24,20.05,6.24-4.52,5.59-6.45S199,152.11,196.41,146c-1.88-4.47-7.31-24.95-7.31-24.95",
    fill: "#68e1fd"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M209.1,170.93a48.83,48.83,0,0,1,1.49,5.41c.32,1.91-1,5.52-2,6.26s-.85,2.23.53,3.18,5.52.42,7-1.06.32-4.27,1.49-6.7,4.25-7.07-3.07-12.44",
    fill: "#341a0c"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M247.64,78.24s3.15-6.42,2.65-7-2.3,2-2.3,2,0-6.58-.56-6.69-.84,4.1-.84,4.1S246,65.75,245,65.75s0,4.67,0,4.67-1.69-2.92-2.25-2.7.84,3.91.84,3.91-1.57-1.32-1.8-1,1.63,4.92,2.81,6a11.92,11.92,0,0,1,2,2.51",
    fill: "#ffe5d0"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M260.29,116.76s-5.55-15.51-7.56-21.32S249.59,77,249.59,77s-6-.34-6.2,1.07.6,37.92,12.84,48.76",
    fill: "#f46d0a"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M249.88,168.6a124.76,124.76,0,0,0-2.24,16.15c-.24,6.42,6.88,25,6.88,25l5-2.63s-5-17.25-4-20.37,5.87-15.6,4.77-18.17S249.88,168.6,249.88,168.6Z",
    fill: "#ffe5d0"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M262.66,169.58a124.76,124.76,0,0,0-2.24,16.15c-.24,6.42,6.74,23.31,6.74,23.31l5.14-.92s-5-17.25-4-20.37,5.87-15.6,4.77-18.17S262.66,169.58,262.66,169.58Z",
    fill: "#ffe5d0"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M265.32,110c.72.77,6.72.73,9.12,4.21s11.38,14.28,11.51,19.5-13.24,13.34-14,12.14-1.74-4.12-.8-5.05,6.15-5.95,6.15-5.95l-5.76-7.53s-4.44,10.07-1.1,17.32,6.37,16.1,2.58,32.81c-1.06,4.68-24.46-.27-25.27-8.15s5.75-20.19,5.61-25.53a77.46,77.46,0,0,0-2.67-18c-1.87-7.35,5.21-15.71,5.21-15.71Z",
    fill: "#f46d0a"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M253.94,208.66s-.18,3.85-2.2,5.69-7.89,3.3-7.16,5.69,3.85,2.2,6.24,1.1,6-5.33,6-5.33a14.85,14.85,0,0,1,.83,3.86l2.36-.73-.61-12.35S258.34,209,253.94,208.66Z",
    fill: "#483d27"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M267.16,209s-.17,4.53-.36,7.07-3.74,9.16-2.47,10.43,3.94,1.14,5.6,0,2.58-8.27,3.26-9.54-.89-8.88-.89-8.88Z",
    fill: "#483d27"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M270.76,142c.49.73-2.49-2.77-3.1-2.33s1.31,2.43,1.31,2.43-4.62,6-2.53,7.27,5.68-3.54,5.68-3.54",
    fill: "#ffe5d0"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M258.34,109.91s-4,7.64-2.91,8.5,7.73,2.49,8.6,1.56,1.29-10,1.29-10",
    fill: "#ffe5d0"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M256.12,100.56s-2.73,7.87-.69,9.09,7.14,0,7.14,0",
    fill: "#40424e"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M255.5,98.9S254.53,110,260,111s6.62-10.5,5.49-12.11S256.95,96.32,255.5,98.9Z",
    fill: "#ffe5d0"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M262.57,107.21a5.72,5.72,0,0,0,.57,4.19A11.73,11.73,0,0,0,270,111c2.94-7.14,0-18-7.22-18.85s-8.28,3.53-8.69,6.11,1.35,2.35,2,2.31C262.23,100.16,263.85,103.14,262.57,107.21Z",
    fill: "#40424e"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    points: "194.15 153.4 193.42 157.41 187.42 158.34 187.22 151.46",
    fill: "#fbe8da"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M225.1,145.36s-3-4.76-2.42-5.12,2.42,1.62,2.42,1.62.54-6.29,1.35-6.55.54,5.57.54,5.57,1.26-5.22,2.16-5.57,0,5,0,5,1.26-3.68,2.07-3.68-1.38,5.12-1.38,5.12,1.56-1.46,2.1-1.45-3.68,6.3-3.68,6.3",
    fill: "#fbe8da"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M152.15,148.63s3.18-5.19,2.08-5.6-2.74,1.75-2.74,1.75-.27-7.09-1.23-7.22-.82,6.16-.82,6.16-1-5.76-1.92-6.16,0,6.16,0,6.16-3.15-4.52-3.83-3.83S145.8,146,145.8,146s-1.78-2-2.22-1.27,4.35,7,4.35,7l5.35-3.26",
    fill: "#fbe8da"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M205.09,260.61s2,7.45,1.74,10.14-2.54,3.43-4.95,2.8-3.76-3.7-7.54-4.31-8.83-5.36-6.57-8.77S203,262,203,262",
    fill: "#2d464b"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M203.72,190.93c-.28.42,2.31,12.23,0,20.7s-6.67,15.06-6.59,18.14,8,30.84,8,30.84-5.94,4.67-9,.82-10.53-22.56-10.74-27.08S190,196.59,190,196.59",
    fill: "#d9e021"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M188.74,249.54s4.43,4.72,6.08,6.86,1.87,4.2-.3,5.41-5.27-.08-8.43,2.1-10.09,2.23-10.81-1.79,12.13-9.43,12.13-9.43",
    fill: "#2d464b"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M180.69,236.67c1.43,4.49,10.78,13.66,11.16,16.79-1.85,2.65-5.73,4.54-8.56,3.43-6.15-6.34-17.64-19-17.18-24.54.62-7.6,11.51-31,11.51-31s17.47-6.37,15.82,5.27S179.25,232.15,180.69,236.67Z",
    fill: "#d9e021"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M181.52,143.13s1.07,13.07,3.63,12.45,7-2.93,6.25-5.47S181.52,143.13,181.52,143.13Z",
    fill: "#fbe8da"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M184.23,145.12s-5.26-.12-4.78-2.87,3.47-3.11,3.47-3.11,0-3.83,1.91-4.19,4.54,2,4.54,2a8.34,8.34,0,0,1,4.19-2.07c2.39-.32,3.95,3.39,3.95,3.39s3,1.08,3.35,3.95-3,2.87-3,2.87,2.51.48,2,2.51a5.07,5.07,0,0,1-2,3,5.06,5.06,0,0,1-4.54,3.47c-3.83.48-6-.72-6.1-2.63s-.6-5-2-2.75Z",
    fill: "#563f2f"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M223.88,144.78s-5.54,16.3-10.77,15.07-14.15-4.56-16.61-4.43-17.69,2.1-19.92,4.5-15,5.16-18.07,3.32-5.23-14.7-5.23-14.7-6.46.39-7.38,1.93,4.61,16.76,9.69,22.15,21-1.85,21-1.85L175,206.6s22.84,5,29.61-7l-.08-30.52s9.84.77,14.15-1.54,12.15-20.3,11.07-21.53S223.88,144.78,223.88,144.78Z",
    fill: "#e84c1c"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M191.62,30.64s1.5,10.19-7.58,11.16c0,0,7,1.72,7.58,7.58,0,0,1.57-6.87,7.3-7.58C198.92,41.8,192.14,43.06,191.62,30.64Z",
    fill: "#f4ba14"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M219.38,56.37s1.5,10.19-7.58,11.16c0,0,7,1.72,7.58,7.58,0,0,1.57-6.87,7.3-7.58C226.68,67.54,219.9,68.79,219.38,56.37Z",
    fill: "#f4ba14"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M110.22,58.71s1.5,10.19-7.58,11.16c0,0,7,1.72,7.58,7.58,0,0,1.57-6.87,7.3-7.58C117.52,69.87,110.74,71.12,110.22,58.71Z",
    fill: "#f4ba14"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M132.83,40s1.5,10.19-7.58,11.16c0,0,7,1.72,7.58,7.58,0,0,1.57-6.87,7.3-7.58C140.13,51.18,133.35,52.43,132.83,40Z",
    fill: "#f4ba14"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M142.66,119s-.46-5.77,0-6.16,1.31,1,1.38,1.84c0,0,.79-1.77,1.44-1.57s3.67,2,3.61,3.41-3.74,5.51-3.74,5.51",
    fill: "#eea7b7"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M86.28,107.25s3-2.49,2.69-3.34-2,1.17-2,1.17.72-3.19-.13-3.52-4-.75-4.34-.14.54,5.83.54,5.83",
    fill: "#eea7b7"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M115.46,184.54s-2.13,12.05-2.51,16.56-.5,16.39-.5,16.39a4.1,4.1,0,0,1-4.88,1.88A106.46,106.46,0,0,1,106.32,201c.38-8.38-.06-20.27-.06-20.27Z",
    fill: "#eea7b7"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M104.57,181.7s-2.13,6.76-4.38,8-23.27,7.13-29.52,14.14c0,0-4.38-.91-4.13-3.71,0,0,5-4.55,10.51-8.55s16.31-5.5,16.85-6.38,1.41-12.38,1.41-12.38",
    fill: "#eea7b7"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M98.61,137.46s-13,13.88-4.41,46.28c0,0,10.93,4,21.27.8,0,0,9.08-28.64-1.12-43.44",
    fill: "#5311a6"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M107.33,112.75c0-.36-.83-2.34.61-3.15s7.39-.85,7.39.48-1,2.91,0,3.51,5.21.36,6.78,1.82,11.27,15.27,13.93,14.18,6.18-11.75,6.18-11.75l4.36,3.15s-.85,13.69-7.27,16.6-21.45-10.3-21.45-10.3-4,9.94-3.53,13.81-16.18,1.62-15.73-3.63c.49-5.68-1.09-14.66-1.09-14.66s-13.93,5.94-18.3,1.33,3.39-18.05,3.39-18.05l4.12,1.09s-3.15,10.18-1.45,10.9,10.52-5.94,15.5-6.18S107.33,112.75,107.33,112.75Z",
    fill: "#68e1fd"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M112.47,216.45s1,3.72,3,3.12,4.06-2.06,4.82-1.3,1.39,1.77.38,2.91-6.58,4.24-6.58,4.24l-3.48-3.17s-.19,5-.57,5.06-2.66.06-2.85-1,0-9.32,0-9.32Z",
    fill: "#4501a4"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M70.67,203.85s-1.8,1.19-.91,2.77,3.54,3.36,3.36,4.18-1.08,2.47-2.28,2-3.23-1.46-3.67-2.34-.51-6-1-6.27-3.67,3.48-4.18,3.17-2.34-2.09-2-2.53,6.59-4.71,6.59-4.71L69,198l3.72,4Z",
    fill: "#4501a4"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M118,103.73s2.91-2.48,2.26-5.17a7.72,7.72,0,0,0-9-5.28c-5.17.86-9.15,5.82-8.94,13.46s12,4.45,12,4.45",
    fill: "#5311a6"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M118.43,98.56s.86,12.17-1.83,12.92-4.52-2.58-4.52-2.58l-.54-2.26s-2.69-2.48-.75-3.23a2.32,2.32,0,0,1,2.91,1s.86-2.48,2.26-1.83S118.43,98.56,118.43,98.56Z",
    fill: "#eea7b7"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M324.67,133.49v50.74a1.5,1.5,0,0,0,3,0V133.49A1.5,1.5,0,0,0,324.67,133.49Z",
    fill: "#341a0c"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M324,172.39l-22.37,22.37a1.5,1.5,0,0,0,2.12,2.12l22.37-22.37A1.5,1.5,0,0,0,324,172.39Z",
    fill: "#341a0c"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M342.71,198.69l-15.64-27.5a1.5,1.5,0,0,0-2.61,1.48l15.64,27.5A1.5,1.5,0,0,0,342.71,198.69Z",
    fill: "#341a0c"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "303.88 87.28 328.8 102.07 355.66 86.3 329.77 71.82 303.88 87.28",
    fill: "#68e1fd"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "355.66 86.3 355.66 143.44 329.77 158.34 328.8 102.07 355.66 86.3",
    fill: "#68e1fd"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "303.88 87.28 328.8 102.07 355.66 86.3 329.77 71.82 303.88 87.28",
    fill: "#606060",
    opacity: 0.11
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "355.66 86.3 355.66 143.44 329.77 158.34 328.8 102.07 355.66 86.3",
    fill: "#606060",
    opacity: 0.52
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    points: "303.88 87.28 303.88 144.15 329.77 158.34 328.8 102.07 303.88 87.28",
    fill: "#68e1fd"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 314.81,
    cy: 109.41,
    rx: 6.01,
    ry: 10.15,
    transform: "translate(-15.94 150.4) rotate(-26.23)",
    fill: "#d740a7"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 314.81,
    cy: 109.64,
    rx: 4.13,
    ry: 6.75,
    transform: "translate(-16.04 150.42) rotate(-26.23)",
    fill: "#6210bc"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 316.07,
    cy: 134.08,
    rx: 8.39,
    ry: 14.17,
    transform: "translate(-26.72 153.5) rotate(-26.23)",
    fill: "#d740a7"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 316.65,
    cy: 132.48,
    rx: 5.19,
    ry: 7.17,
    transform: "translate(-25.95 153.59) rotate(-26.23)",
    fill: "#6210bc"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M326.56,183.5c-6.7,4.76-29.49,14-36.31,18.53l27.63,16.39,23.57-17.79Z",
    opacity: 0.5,
    fill: "url(#linear-gradient-8)",
    style: {
      mixBlendMode: "multiply"
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvent);
export default __webpack_public_path__ + "static/media/event.1abaf3f3fa77c6aa61066bae4ea78309.svg";
export { ForwardRef as ReactComponent };